import React from 'react'
import { Stack, Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { CreditCardRounded } from '@mui/icons-material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ChargingSessionSearchResponseModel } from '../models/charging-sessions.model'
import { getAuthenticationLabel } from '../utils/get-authentication-label'

const useStyles = makeStyles()(() => ({
  wordBreak: {
    overflowWrap: 'anywhere',
    hyphens: 'auto',
  },
}))

interface AuthenticationCellProps {
  authentication: ChargingSessionSearchResponseModel['content'][0]['authentication']
  rfid?: string | null
  cardName: string | undefined
}

export const AuthenticationInfo: React.VFC<AuthenticationCellProps> = ({ authentication, rfid, cardName }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  /**
   * Backend implementation of GET charging sessions endpoint is such that all unauthenticated sessions(the ones started
   * without a charging card) are started under the hood using the so called "ZERO" card/token.
   *
   * In case we detect that the "ZERO" token was used, we consider the session as "Unauthorized" and display
   * it to users as such.
   */
  if (!authentication.isAuthenticated) {
    return (
      <Typography variant="body2" color="text.disabled">
        {t('emobility.chargingSession.noAuthentication')}
      </Typography>
    )
  }

  return (
    <Stack direction="row" spacing={2}>
      <CreditCardRounded />
      <Typography variant="body2" alignSelf="center" className={classes.wordBreak}>
        {getAuthenticationLabel({
          rfid,
          cardName,
          authenticationMethod: authentication.authenticationMethod,
          isAuthenticated: authentication.isAuthenticated,
          t,
        })}
      </Typography>
    </Stack>
  )
}
